const scrollBarWidth = $(window).outerWidth() - $(window).innerWidth();

const toggleScroll = () => {
  $(window).scroll(() => false);

  const $html = $('html');
  $html.toggleClass('hidden');

  if (window.matchMedia('(min-width: 992px)').matches) {
    if ($html.hasClass('hidden')) {
      $html.css({
        'margin-right': `${scrollBarWidth}px`,
        overflow: 'hidden',
      });
    } else {
      setTimeout(() => {
        $html.css({
          width: 'auto',
          'margin-right': '0',
          overflow: 'visible',
        });
      }, 400);
    }
    return;
  }

  if ($html.hasClass('hidden')) {
    $html.css({
      overflow: 'hidden',
    });
  } else {
    setTimeout(() => {
      $html.css({
        overflow: 'visible',
      });
    }, 100);
  }
};


export default toggleScroll;
